import { MobileType, ApiInfoStatus } from '@/type/enums';

export function format(list: any): any {
    const res = {
        mobileType: [],
        needTypes: [],
    };
    const innerFunc = (input: Record<string, any>, sourceList: any) => {
        sourceList.forEach((item: any) => {
            const { selected, type, sub, fields } = item;
            const typeIsNum = typeof type === 'number';
            if (!typeIsNum && sub?.length) {
                selected
                    ? input.needTypes.push(
                          sub.map((subItem: any) => subItem.type),
                      )
                    : sub.forEach((subItem: any) => {
                          subItem.selected = false;
                      });
            }
            if (selected && typeIsNum) {
                (input.mobileType as MobileType[]).push(type);
            }
            if (fields) {
                selected
                    ? fields.forEach((field: any) => {
                          input[field.key] = field.value;
                      })
                    : fields.forEach((field: any) => {
                          input[field.key] = '';
                      });
            }
            if (sub?.length) {
                innerFunc(input, sub);
            }
        });
    };
    innerFunc(res, list);
    return res;
}

export function convertApiStatusText(status: number, option?: 'mpPlc') {
    let text = '';
    switch (status) {
        case ApiInfoStatus.applied:
            text = option === 'mpPlc' ? '已申请' : '已获取';
            break;
        case ApiInfoStatus.notApply:
            text = '未获取';
            break;
        case ApiInfoStatus.applying:
            text = '申请中';
            break;
        case ApiInfoStatus.applyRefused:
            text = '申请驳回';
            break;
    }
    return text;
}

export const isGtWH = (width: number, height: number, file: File) => {
    return new Promise((resolve, reject) => {
        const _URL = window.URL || window.webkitURL;
        const img = new Image();

        img.onload = function () {
            const valid = img.width >= width && img.height >= height;
            if (valid) {
                resolve(null);
            } else {
                reject(null);
            }
        };
        img.src = _URL.createObjectURL(file);
    });
};

export const dataURLtoFile = (dataurl: string, filename: string) => {
    const arr = dataurl.split(',');
    const mime = /:(.*?);/.exec(arr[0])?.[1];
    const bstr = atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);
    while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
    }
    return new File([u8arr], filename, { type: mime });
};

export const compressImage = (file: File, minSize: number, maxSize: number): Promise<File> => {
    return new Promise((resolve, reject) => {
        const img = new Image();
        img.src = URL.createObjectURL(file);

        img.onload = () => {
            const canvas = document.createElement('canvas');
            const ctx = canvas.getContext('2d')!;
            canvas.width = img.width;
            canvas.height = img.height;
            ctx.drawImage(img, 0, 0, img.width, img.height);

            let leftQuality = 0.1;
            let rightQuality = 1;
            let quality; let newSize;
            while (rightQuality - leftQuality > 1e-5) {
                quality = (leftQuality + rightQuality) / 2;
                const newDataUrl = canvas.toDataURL('image/jpeg', quality);
                newSize = atob(newDataUrl.split(',')[1]).length;
                if (newSize < minSize) {
                    leftQuality = quality;
                } else if (newSize > maxSize) {
                    rightQuality = quality;
                } else {
                    resolve(dataURLtoFile(newDataUrl, file.name));
                    return;
                }
            }
            reject();
        };

        img.onerror = reject;
    });
};


// 复制
export function copyText(text: string, callback: any) {
    const order_sn = text;
    const oInput = document.createElement('textarea');
    //  之前用的 input 无法换行
    //  oInput.value = order_sn;
    //  document.body.appendChild(oInput);

    oInput.setAttribute('readonly', 'readonly');
    oInput.setAttribute('id', 'textarea_id');
    // oInput.style.display = 'none';
    // 不影响正常布局
    oInput.style.position = 'absolute';
    oInput.style.top = '-50px';
    oInput.style.left = '-50px';

    document.body.appendChild(oInput);
    const textarea_id = document.getElementById('textarea_id') as HTMLTextAreaElement;
    textarea_id.innerHTML = order_sn;

    // 选择对象
    oInput.select();
    // 执行浏览器复制命令
    const a = document.execCommand('Copy');
    // 兼容ios
    if (!a) {
        oInput.select(); // 选择对象
        oInput.setSelectionRange(0, oInput.value.length);
        // 执行浏览器复制命令
        document.execCommand('Copy');
    }
    document.body.removeChild(oInput);
    if (callback) {
        callback(text);
    }
}


export function checkAndCompleteMobileType(appInfo: any) {
    const mobileTypeSet = new Set(appInfo.mobileType);

    const typeConditions: { type: MobileType, keys: (string)[] }[] = [
        { type: MobileType.ios, keys: ['iosBundleId', 'iosTestBundleId', 'universalLink', 'iosDownUrl'] },
        { type: MobileType.ipad, keys: ['ipadBundleId', 'ipadTestBundleId', 'ipadUniversalLink', 'ipadDownUrl'] },
        { type: MobileType.android, keys: ['androidPackage', 'androidSign', 'androidDownUrl'] },
        { type: MobileType.harmony, keys: ['harmonyBundleId', 'harmonyIdentifier'] },
    ];

    const hasAnyValue = (obj: any, keys: (string)[]): boolean => {
        return keys.some(key => !!obj[key]);
    }

    typeConditions.forEach(condition => {
        if (hasAnyValue(appInfo, condition.keys)) {
            mobileTypeSet.add(condition.type);
        }
    });

    appInfo.mobileType = Array.from(mobileTypeSet);

    return appInfo;
}
